import { ResourceTypes, ResourceTypesLabels } from '@/models/resources';

export const mapResourceType = {
  [ResourceTypesLabels.Podcast]: ResourceTypes.Podcast,
  [ResourceTypesLabels.Book]: ResourceTypes.Book,
  [ResourceTypesLabels.Course]: ResourceTypes.Course,
  [ResourceTypesLabels.Document]: ResourceTypes.Document,
  [ResourceTypesLabels.EventOrLecture]: ResourceTypes.EventOrLecture,
  [ResourceTypesLabels.Video]: ResourceTypes.Video,
  [ResourceTypesLabels.Others]: ResourceTypes.Others,
};

export const mapResourceTypeToLabel = {
  [ResourceTypes.Podcast]: ResourceTypesLabels.Podcast,
  [ResourceTypes.Book]: ResourceTypesLabels.Book,
  [ResourceTypes.Course]: ResourceTypesLabels.Course,
  [ResourceTypes.Document]: ResourceTypesLabels.Document,
  [ResourceTypes.EventOrLecture]: ResourceTypesLabels.EventOrLecture,
  [ResourceTypes.Video]: ResourceTypesLabels.Video,
  [ResourceTypes.Others]: ResourceTypesLabels.Others,
};
